import { render } from "./documentManagement.vue?vue&type=template&id=4e00eb3e&scoped=true"
import script from "./documentManagement.vue?vue&type=script&lang=js"
export * from "./documentManagement.vue?vue&type=script&lang=js"

import "./documentManagement.vue?vue&type=style&index=0&id=4e00eb3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e00eb3e"]])

export default __exports__